angular.module('elogbooksServices').service('reportTotalsService', function ($q, apiClient, lodash) {
    this.getTotalsData = getTotalsData;
    this.getCachedTotals = getCachedTotals;
    this.compareStateParams = compareStateParams;
    this.isCachedDataValid = isCachedDataValid;
    this.getIndividualTotalsData = getIndividualTotalsData;
    this.getCachedIndividualTotals = getCachedIndividualTotals;
    this.isCachedIndividualDataValid = isCachedIndividualDataValid;
    this.clearCache = clearCache;

    var totals = {};
    var previousStateParams = {};

    // Individual totals functionality
    var individualTotals = {};
    var loadingStates = {};
    var individualPreviousStateParams = {};

    // Define the 9 report types supported by the backend
    var reportTypes = [
        'reactiveMissedAttendance',
        'reactiveMissedCompletion',
        'plannedMissedAttendance',
        'plannedMissedCompletion',
        'quotesMissedCompletion',
        'escalations',
        'extensionRequests',
        'reopenedJobs',
        'paperworkAwaiting'
    ];

    function isCachedDataValid($stateParams) {
        if (compareStateParams($stateParams)) {
            return false;
        }
        return true;
    }

    function getCachedTotals() {
        return totals;
    }

    function getTotalsData($stateParams, route) {
        if (lodash.isEmpty(totals) || compareStateParams($stateParams)) {
            previousStateParams = $stateParams;

            if (route === '/reports/sp-summary-totals') {
                return apiClient.get('/reports/sp-summary-totals', $stateParams).then(function (response) {
                    totals = response;
                    return response;
                });
            } else if(route === '/reports/sp-summary') {
                return apiClient.get('/reports/sp-summary', $stateParams).then(function (response) {
                    totals = response;
                    return response;
                });
            } else {
                return apiClient.get('/reports/kpi-monthly-average', $stateParams).then(function (response) {
                    totals = response;
                    return response;
                });
            }
        } else {
            return totals;
        }
    }

    function compareStateParams($stateParams) {
        //strip page number and showPercentages as it will invalidate the comparison
        var previous = angular.copy(previousStateParams);
        var current = angular.copy($stateParams);

        if (previous.page) {
            delete previous.page;
        }

        if (previous.showPercentages) {
            delete previous.showPercentages;
        }

        if (current.page) {
            delete current.page;
        }

        if (current.showPercentages) {
            delete current.showPercentages;
        }

        return JSON.stringify(previous) !== JSON.stringify(current);
    }

    // Individual totals functions
    function clearCache() {
        individualTotals = {};
        loadingStates = {};
        individualPreviousStateParams = {};
    }

    function isCachedIndividualDataValid($stateParams) {
        // If no previous params exist, cache is invalid
        if (lodash.isEmpty(individualPreviousStateParams)) {
            return false;
        }
        // If no cached data exists, cache is invalid
        if (lodash.isEmpty(individualTotals)) {
            return false;
        }
        const paramsChanged = compareIndividualStateParams($stateParams);
        return !paramsChanged;
    }

    function getCachedIndividualTotals() {
        return {
            totals: individualTotals,
            loadingStates: loadingStates
        };
    }

    function getIndividualTotalsData($stateParams) {
        var promises = {};
        var hasParamsChanged = compareIndividualStateParams($stateParams);

        if (hasParamsChanged) {
            individualPreviousStateParams = angular.copy($stateParams);
            clearCache();
        }

        // Create individual API calls for each report type
        reportTypes.forEach(function(reportType) {
            if (!individualTotals[reportType] || hasParamsChanged) {
                loadingStates[reportType] = true;

                var params = angular.copy($stateParams);
                params['reportTypes[]'] = reportType;

                promises[reportType] = apiClient.get('/reports/sp-summary-totals', params)
                    .then(function(response) {
                        individualTotals[reportType] = response;
                        loadingStates[reportType] = false;
                        return response;
                    })
                    .catch(function(error) {
                        loadingStates[reportType] = false;
                        console.error('Error loading ' + reportType + ':', error);
                        return null;
                    });
            } else {
                // Return cached data as resolved promise
                promises[reportType] = $q.resolve(individualTotals[reportType]);
            }
        });

        return {
            promises: promises,
            loadingStates: loadingStates,
            totals: individualTotals
        };
    }

    function compareIndividualStateParams($stateParams) {
        //strip page number and showPercentages as it will invalidate the comparison
        var previous = angular.copy(individualPreviousStateParams);
        var current = angular.copy($stateParams);

        if (previous.page) {
            delete previous.page;
        }

        if (previous.showPercentages) {
            delete previous.showPercentages;
        }

        if (current.page) {
            delete current.page;
        }

        if (current.showPercentages) {
            delete current.showPercentages;
        }

        return JSON.stringify(previous) !== JSON.stringify(current);
    }
});
